import * as React from 'react'
import { connect } from 'react-redux'
import Content from '../../pages/shared/content'

import { ListItem } from 'components/List'
import AirportSummary from './shared/AirportSummary'
import DaysSummary from './shared/DaysSummary'
import DepartureDate from './shared/DepartureDate'
import ExcludedCitiesSummary from './shared/ExcludedCitiesSummary'
import NoteSummary from './shared/NoteSummary'
import NrPeopleSummary from './shared/NrPeopleSummary'

import { FunnelOrder } from '../../data/models/funnelOrder'
import { getDestination } from '../../data/models/funnelOrder/summary'
import { AppState } from '../../data/state'

interface FlySummaryProps {
  funnelOrder: FunnelOrder
  loading: boolean
  final?: boolean
}

const SoloSummary: React.FC<FlySummaryProps> = ({ funnelOrder, loading }) => {
  const loadingClass = loading ? 'is-loading' : ''
  return (
    <>
      <NrPeopleSummary />
      <DepartureDate />
      <DaysSummary
        contentKey="solotrip-summary"
        getDestination={getDestination}
        destination={funnelOrder.destination}
      />
      <ExcludedCitiesSummary />
      <AirportSummary />
      <ListItem>
        <Content addNode contentKey="solo-times-summary">
          Outgoing: 07:00 - 15:00 / Inbound: 13:00 - 22:00
        </Content>
      </ListItem>
      <ListItem>
        <Content addNode contentKey="solo-accomodation">
          Shared accomodation with private room
        </Content>
      </ListItem>
      <NoteSummary />
    </>
  )
}

export default connect((state: AppState) => ({
  funnelOrder: state.funnelOrder,
  loading: state.contentEngine.loading,
}))(SoloSummary)
